/** Versione del portale, letta da package.json al build (unica fonte di verità). */
import { version } from '../package.json';

export const APP_VERSION: string = version;
